import { Theme } from '@mui/material';
import { BrandColors } from '../../constants';
import { TemplateSettings } from '../../store/interfaces';
import { makeStyles } from 'tss-react/mui';

export const BaseStyles = makeStyles<TemplateSettings>()((theme: Theme, props) => ({
  header: {
    backgroundColor: props.utilityBar.backgroundColor,
    color: props.utilityBar.textColor,
    boxShadow: `0px 3px 3px ${BrandColors.blackWithOpacity}`,
    height: '2.5rem',
    padding: '0 24px',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      padding: '0 80px',
      height: '3.125rem',
    },
    [theme.breakpoints.up('xl')]: {
      padding: '0 113px',
    },
  },
  eventHeader: {
    backgroundColor: props.utilityBar.backgroundColor,
    color: props.utilityBar.textColor,
    boxShadow: `0px 3px 3px ${BrandColors.blackWithOpacity}`,
    height: '2.5rem',
    padding: '0 1.875rem',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      padding: '0 2.5rem',
    },
    [theme.breakpoints.up('md')]: {
      height: '3.125rem',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '0 5rem',
    },
  },
  mobile: {
    [theme.breakpoints.down('lg')]: {
      position: 'relative',
    },
  },
  logo: {
    display: 'flex',
    height: '2.5rem',
    width: '12rem',
    '& > a': {
      display: 'flex',
      height: 'auto',
      width: 'auto',
    },
    '& > a > img': {
      margin: '0.125rem 0',
      maxWidth: '12rem',
      maxHeight: '2.5rem',
    },
    [theme.breakpoints.up('lg')]: {
      height: '3.125rem',
      width: '15rem',
      '& > a > img': {
        maxWidth: '15rem',
        maxHeight: '3.125rem',
      },
    },
  },
  logoContainer: {
    flexGrow: 1,
  },
  headerBtn: {
    fontSize: '16px',
    padding: '2px 10px',
    marginLeft: '24px',
  },
  content: {
    marginTop: '40px',
    minHeight: 'calc(100vh - 40px - 165px)',
    [theme.breakpoints.up('md')]: {
      marginTop: '50px',
      minHeight: 'calc(100vh - 50px - 165px)',
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 'calc(100vh - 50px - 97px)',
    },

    '@supports (height: 100svh)': {
      minHeight: 'calc(100svh - 40px - 165px)',
      [theme.breakpoints.up('md')]: {
        marginTop: '50px',
        minHeight: 'calc(100svh - 50px - 165px)',
      },
      [theme.breakpoints.up('lg')]: {
        minHeight: 'calc(100svh - 50px - 97px)',
      },
    },
  },
  dektopMenuItem: {
    backgroundColor: props.utilityBar.backgroundColor,
    color: `${props.utilityBar.textColor} !important`,
    border: 'none',
    fontSize: '1rem',
    lineHeight: '22px',
    '&:focus-visible': {
      zIndex: 1,
    },
  },
  desktopMenuUserProfile: {
    backgroundColor: `${props.utilityBar.backgroundColor} !important`,
    minWidth: '9rem',
    border: 'none',
  },
  desktopMenuSettings: {
    backgroundColor: props.utilityBar.backgroundColor,
    padding: '0.25rem 0 0.25rem',
    minWidth: '200px',
    '& .language-label': {
      color: props.utilityBar.textColor,
      fontSize: '1rem',
      padding: '0 0.5rem 0.25rem',
    },
    borderRadius: '0.3125rem',
  },
  desktopAccessibilitySettings: {
    backgroundColor: props.utilityBar.backgroundColor,
    padding: '1.5rem 0.75rem 0.75rem',
    minWidth: '300px',
    textAlign: 'center',
  },
  buttonProgress: {
    color: 'inherit',
    margin: '0px 0px 0px 5px',
  },
  skipToMainContentLink: {
    position: 'fixed',
    width: '100%',
    height: '3rem',
    padding: '0.625rem 1.125rem',
    backgroundColor: theme.palette.primary.main,
    color: `${theme.palette.primary.contrastText} !important`,
    opacity: 0,
    top: 0,
    fontSize: '14px',
    lineHeight: '24px',
    '&:focus': {
      opacity: 1,
      outline: 'none',
      zIndex: 1110,
    },
    '&:focus+.MuiAppBar-root': {
      top: '3rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '12px',
    },
    '& span': {
      border: `2px solid ${BrandColors.focusOutline}`,
      padding: '4px',
    },
  },
  expandIcon: {
    fontSize: '1rem !important',
  },
}));
